<div *ngIf="RoleId=='1' || RoleId=='2'" class="col-lg-12">

  <div class="card" style="width:100%;">
    <p class="alert alert-danger" id="successMessage" *ngIf="result.UpdateError != null">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{result.UpdateError}}
    </p>
    <p class="alert alert-danger" id="successMessage" *ngIf="result._Status != null">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{result._Status}}
    </p>

    <br />
    <h3 class="heading3" style="text-align:center;">Update Tax Code Mapping</h3>

    <br><br>
    <!-- <div class="center" >
      
      <form  
        enctype="multipart/form-data"
        class="dropzone dz-clickable" id="dropzoneForm" style="width:auto;margin:0 100px;position:relative;height:250px">
        <div class="dz-default dz-message"><img src="./assets/static/upload.png"><br><br>
          <span style="color:#808080 !important;">
            <b>Click to browse for files</b>
          </span>
        </div>
        <div class="fallback">
          <input type="file" (change)="fileChange($event)" multiple id="btnUpload" value="Upload" class="upload" />
          <br>
          <input type="submit" value="Upload">
        </div>
      </form>
        
    </div > -->

    <div class="center">
      <form enctype="multipart/form-data" class="dropzone dz-clickable"
        style="width:auto;margin:0 100px;position:relative;height:250px" [dropzone]="config"
        (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
        <div class="dz-default dz-message">
          <img src="./assets/static/upload.png">
          <br>
          <br>
          <span style="color:#808080 !important;">
            <b>Drag and Drop or Click to browse for files</b>
          </span>
        </div>
        <!-- <div class="fallback">
          <input type="file" (change)="fileChange($event)" multiple id="btnUpload" value="Upload" class="upload" />
          <br>
          <input type="submit" value="Upload">
        </div> -->
      </form>

    </div>

    <br><br />

    <div class="center">

      <a routerLink="/Home"><button id="preprocess" class="btn btn-lg btn-primary buttonStyle">Back to Home</button></a>
    </div>

    <br /><br /><br />

    <br />

  </div>
</div>